<div class="rounded-1 bg-white p-2">
  @for (button of tabButtons(); track button.key) {
    <button
      class="btn popout-button"
      (click)="activeTabButtonKey.set(button.key)"
      [class.me-2]="!$last"
      [class.active]="button.key === activeTabButtonKey()"
    >
      {{ button.translationLabel | translate }}
    </button>
  }
</div>
